const fileNameExtension = (fileName) => {
  const parts = fileName.split(".");
  return parts[parts.length - 1].toLowerCase();
};

export const validateCvFile = (file) => {
  const allowedExtensions = ["doc", "docx", "pdf"];
  if (!file) return "fileMissing";
  if (file.size === 0) {
    return "fileEmpty";
  }

  const extension = fileNameExtension(file.name);
  if (!allowedExtensions.includes(extension) || !file.name.includes(".")) {
    return "formatInvalid";
  }
  return "";
};

export const saveCV = ({ appData, updateCV, cvFile }) => {
  const { candidateRef, emailAddress } = appData || {};
  const userData = { candidateRef, emailAddress };
  const updatedUserData = {
    ...userData,
    cvFile,
  };
  updateCV(candidateRef, updatedUserData);
};
